import EmblaCarousel from 'embla-carousel';

class CollectionGallery {
  constructor() {
    this.els = document.querySelectorAll('[js-collection-gallery]');
    if (!this.els.length) return;

    this.els.forEach((el) => this.init(el));
  }

  init(el) {
    const viewport = el.querySelector('[js-collection-gallery-viewport]');
    const slides = el.querySelectorAll('.ird-cl-gallery__slide');
    if (!viewport || slides.length <= 1) return;

    const prevButton = el.querySelector('[js-collection-gallery-prev]');
    const nextButton = el.querySelector('[js-collection-gallery-next]');
    const embla = EmblaCarousel(viewport, {
      loop: false,
      align: 'start',
      dragFree: true,
    });

    prevButton?.addEventListener('click', () => embla.scrollPrev());
    nextButton?.addEventListener('click', () => embla.scrollNext());

    const updateButtons = () => {
      if (prevButton) prevButton.disabled = !embla.canScrollPrev();
      if (nextButton) nextButton.disabled = !embla.canScrollNext();
    };

    updateButtons();
    embla.on('scroll', updateButtons);
    embla.on('resize', updateButtons);
  }
}

export default CollectionGallery;
